import { PinThemeAnswerCard, PinThemeEntry } from '@lessonup/pins-shared';
import { defaultPinTheme } from './defaultPinTheme';

export const getPinThemeAnserCard = (pinThemeEntry: PinThemeEntry): PinThemeAnswerCard => {
  const answerCard = 'answerCard' in pinThemeEntry ? pinThemeEntry.answerCard : undefined;
  return answerCard ?? defaultPinTheme.interactive.answerCard;
};
